// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--CArZY","aside":"a10a3f92e9--aside--J19fw","buttons":"a10a3f92e9--buttons--Vt73_","button":"a10a3f92e9--button--vDvJp"};